const DEFAULT_DELETE_ERROR = 'Something went wrong while deleting the note. Try again later.';

/**
 * Resolve the alert message for a failed note delete.
 *
 * When a note has been moved to a team the backend blocks the creator's delete
 * with a 403 and a user-facing `detail`. Surface that message directly; fall
 * back to the generic message for any other failure.
 */
export function getDeleteNoteErrorMessage(error: unknown): string {
  const err = error as { status?: number; detail?: string } | null;
  if (err && err.status === 403 && typeof err.detail === 'string' && err.detail.trim()) {
    return err.detail;
  }
  return DEFAULT_DELETE_ERROR;
}
